<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">New personal list name</label>
          <b-form-input
              type="text"
              :state="informationValidation.isListNameProvided"
              v-model="personalListDetails.toDoListName"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isListNameProvided">
            This field must not be empty.
          </b-form-invalid-feedback>
        </b-col>

      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">List description (optional)</label>
          <b-form-input
              type="text"
              v-model="personalListDetails.toDoListDescription"></b-form-input>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="createPersonalList">Create personal list</b-button>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";

  export default {
    name: "PersonalListCreation.vue",
    data() {
      return {
        personalListDetails: {
          toDoListDescription: null,
          toDoListName: null
        },
        informationValidation: {
          isListNameProvided: null
        },
      }
    },
    validations: {
      personalListDetails: {
        toDoListName: {
          required
        }
      }
    },
    methods: {
      createPersonalList() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.personalListDetails.toDoListName.required) {
          this.informationValidation.isListNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isListNameProvided = true
        }

        if (isValid) {
          this.$store.dispatch('createNewPersonalList', this.personalListDetails)
          this.hideModal('creation-modal')
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
